import { render, staticRenderFns } from "./PostPrize.vue?vue&type=template&id=a93a5570&"
import script from "./PostPrize.vue?vue&type=script&lang=js&"
export * from "./PostPrize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports